import { useEffect } from 'react';

const useAverageScoreEffect = (average_scores, title, setAverageScore) => {
  useEffect(() => {
    if (title === 'Hälsa') {
      setAverageScore(average_scores?.health ?? 0);
    } else if (title === 'Miljö') {
      setAverageScore(average_scores?.environment ?? 0);
    } else {
      setAverageScore(average_scores?.social ?? 0);
    }
  }, [average_scores, title, setAverageScore]);
};

export default useAverageScoreEffect;
